import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { SlotsBatch } from '../../../models/slots-batch.model';

@Component({
  selector: 'ag-slots-active-details',
  templateUrl: './slots-active-details.component.html',
  styleUrls: ['./slots-active-details.component.scss']
})
export class SlotsActiveDetailsComponent implements OnChanges {

  @Input() public batches: SlotsBatch[];

  public total: number = 0;
  public activated: number = 0;
  public arrived: number = 0;
  public unloaded: number = 0;

  ngOnChanges(changes: SimpleChanges): void {
    this.total = 0;
    this.activated = 0;
    this.arrived = 0;
    this.unloaded = 0;

    if (this.batches) {
      this.batches.forEach(batch => {
        this.activated += batch.slots_activated;
        this.arrived += batch.slots_arrived;
        this.unloaded += batch.slots_unloaded;
      });
      this.total = this.activated + this.arrived + this.unloaded;
    }
  }
}
